export default () => ({
  loginRequest: {
    email: '',
    password: ''
  },
  resetPasswordRequest: {
    token: '',
    id: '',
    password: '',
    confirmPassword: ''
  },
  status: {},
  twoFactorAuthRequired: false,
  // Both come from the login response, not from the absence of a code challenge: a device-trust login completes without one for an enrolled user.
  hasMfa: false,
  enforceMfa: false
});
